import { createSignal } from '@verclam/pulsar';

/** Key of the title being edited, `null` when none is: only one title is edited at a time. */
const editedTitleSignal = createSignal<string | null>(null);

export const setEditedTitle = (editKey: string | null) => {
	editedTitleSignal.value = editKey;
};

export default editedTitleSignal;
